<template>
  <div>
    <div class="mt-4">
      <b-row>
        <b-col cols="12" class="text-right">
          <button
            type="button"
            class="btn btn-lightgray ml-2 position-relative"
            v-if="filterheaders.length > 0"
            @click="showFilter"
          >
            <i class="fa fa-filter"></i>
          </button>
          <button
            v-if="filterCatch && Object.values(paramsPage).length > 0"
            type="button"
            class="btn btn-danger mx-2 position-relative"
            @click="deleteFilterCacheResource"
            v-b-tooltip.hover
            :title="`پاک کردن فیلتر`"
          >
            <mdicon
              name="filter-remove-outline"
              size="24"
              class="cursor_pointer"
            />
          </button>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="filter" :class="`my-2 ${classFilter}`">
          <b-row>
            <b-col>
              <advanceFilter
                ref="advanceFilter"
                :headers="filterheaders"
                @getFilterItems="getFilterItems"
                @getFilterDate="getFilterDate"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col :class="classData">
          <b-card-group v-for="(item, i) in items" :key="i" class="my-1" deck>
            <b-card>
              <template #header>
                <div class="float-right">
                  <b-button variant="success" class="mx-1" size="sm">
                    <span key="fa-edit"><i class="fas fa-edit fa-lg"></i></span>
                  </b-button>
                  <b-button variant="danger" class="mx-1" size="sm">
                    <span key="fa-times"
                      ><i class="fas fa-times fa-lg"></i
                    ></span>
                  </b-button>
                </div>
              </template>
              <b-row>
                <!-- <b-col v-for="(label, i) in Object.keys(item)" :key="i" :class="classShow">
                  {{ label }} : {{ item[label] }}
                  {{label}}
                </b-col> -->

                <!-- <template v-for="(_, slotName) of items" v-slot:[slotName]="scope" class="hi">
                  <slot :name="slotName" v-bind="scope" class="mehdi" />

                  <slot name="todo" v-bind:todo="todo">
                </template> -->

                <!-- <template v-for="todo,i in items" :key="i">
                  <slot name="todo" v-bind:todo="todo">
                  
                  </slot>
                </template> -->
                <!-- <slot :name="item"></slot> -->
                <!-- <div v-for="item,i in items" :key="i">
                </div> -->

                <!-- <template v-for="(label, y) in Object.keys(item)" >
                   <slot name="label" :row="item" :key="y" />
                   </template> -->
              </b-row>
              <!-- <template #footer>
                <em>Footer Slot</em>
              </template> -->
            </b-card>
          </b-card-group>
          <paganationSearch
            :allowPaginate="allowPaginate"
            :total="totalRows"
            :total_pages="total_pages"
            :perPage="per_page"
            v-model="page"
            @input="paging"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import paganationSearch from "@/components/base/paganationSearch";
import advanceFilter from "@/components/base/advanceFilter";
import filterMethods from "@/mixin/filterMethods.js";
export default {
  extends: filterMethods,
  components: {
    paganationSearch,
    advanceFilter,
  },
  inject: ["personRepository"],
  props: {
    allowFields: {
      type: Object,
      default: () => {},
    },
    classShow: {
      type: String,
      default: "col-12 col-md-12",
    },
    serviesProvider: {
      type: String,
    },
  },
  data() {
    return {
      items: [],
      columns: [],
      allowPaginate: true,
      filterCatch: false,
      total_pages: 0,
      per_page: 0,
      totalRows: 0,
      filterheaders: [],
      filter: false,
      page: 1,
      paramsPage: {},
      classData: "col-12",
    };
  },
  methods: {
    async fillTable() {
      if (this.filterCatch) {
        let params = await this.getFilterCacheResource();
        for (const key in params) {
          if (params.hasOwnProperty.call(params, key)) {
            const element = params[key];
            this.paramsPage[key] = element;
          }
        }
      } else {
        this.paramsPage["page"] = 1;
        this.paramsPage["per_page"] = this.defaultViewCount;
      }
      // this.paramsPage
      await this.getItems();
      return true;
    },
    showFilter() {
      this.filter = !this.filter;
      if (this.filter) {
        this.classFilter = "col-12 col-md-2";
        this.classData = "col-12 col-md-10";
      } else {
        this.classFilter = "";
        this.classData = "col-12";
      }
    },
    paging(page) {
      this.paramsPage["page"] = page;
      this.getItems();
    },
    async getItems() {
      try {
        let params = {
          ...this.paramsPage,
        };
        const response = await this[this.serviesProvider].list(params);
        let items = response.data.data.result;
        if (!this.filterheaders.length > 0) {
          this.filterheaders = response.data.filters.map((x) => {
            return {
              key_filter_caption: x.key_filter_caption,
              key_filter_name: x.key_filter_name,
              key_service: x.key_service,
              open: x.open,
              type: x.type,
              search_scope: x.search_scope,
              loader: !x.open,
            };
          });
        }
        this.totalRows = response.data.data.total;
        this.total_pages = response.data.data.total_pages;
        this.per_page = response.data.data.per_page;
        let columns = Object.keys(this.allowFields).map((item) => {
          return {
            label: this.allowFields[item],
            key: item,
            sortable: true,
          };
        });
        let rows = [];
        rows = items.map((item) => {
          let each = {};
          columns.map((column) => {
            let spliceKey = column.key.split(".");
            each[column.key] =
              column.key.split(".").length == 2
                ? item[spliceKey[0]][spliceKey[1]]
                : item[spliceKey[0]];
          });
          return each;
        });
        this.items = rows;
      } catch (err) {
        //
      }
    },
  },
  created() {
    this.fillTable();
  },
};
</script>
